export default class AddedOutcomesModifier {
    constructor(modelKeyRepository) {
        this._modelKeyRepository = modelKeyRepository;
    }

    modify(content) {
        if (!content.groups) {
            content.groups = {add: []};
        } else {
            content.groups.add = [];
        }
        if (content.outcomes === undefined || content.outcomes.add === undefined) {
            return;
        }

        const outcomes = content.outcomes.add;

        const groups = [];
        for (let i = 0; i < outcomes.length; i++) {
            const outcome = outcomes[i];

            const key = this._modelKeyRepository.addOutcome(outcome.e, outcome.id);

            const groupId = parseInt(`${outcome.e}${outcome.g || 0}`);
            outcomes[i] = Object.assign({
                type: outcome.t,
                condition: outcome.c,
                conditionTwo: outcome.c2,
                conditionThree: outcome.c3,
                groupId: groupId,
                isHeader: outcome.ih,
                playerId: outcome.p,
                playerName: outcome.pn,
                teamOne: outcome.t1,
                teamTwo: outcome.t2
            }, key);

            let group = groups.find(g => g.id === groupId);
            if (!group) {
                group = {
                    id: groupId,
                    sportId: key.sportId,
                    leagueId: key.leagueId,
                    matchId: key.matchId,
                    type: outcome.g || 0
                };

                groups.push(group);
            }
        }

        if (!content.groups) {
            content.groups = {add: groups};
        } else {
            content.groups.add = groups;
        }
    }
}



// WEBPACK FOOTER //
// ./js/repositories/modifier/AddedOutcomesModifier.js